import React from 'react';
import {
    SimpleForm,
    TextInput,
    NumberInput,
    CreateButton
} from 'react-admin';
import {
    EditNode,
    EditNodeToolbar,
    TreeWithDetails,
} from '@react-admin/ra-tree';
import HierarchyEdit from './HierarchyEdit';

// export const InMarketHierarchyEdit = () => (
//     <EditNode>
//         <SimpleForm toolbar={<EditNodeToolbar />}>
//             <NumberInput source="id" /> 
//             <TextInput source="text" />
//             <NumberInput source="parent_id" /> 
//         </SimpleForm>
//     </EditNode>
// );

export const InMarketHierarchyList = () => {
    const EditComponet = HierarchyEdit
    return (
        <TreeWithDetails
            titleField='text' 
            linkTo="edit"
            allowMultipleRoots
            edit={EditComponet}
            nodeActions={<div></div>}
            addRootButton={<CreateButton label="Add In Market Hierarchy Root" />}
        />
    )};

export default InMarketHierarchyList;

